import { FILTER_PAGE } from './constants'

export const filterPage = (page = '', event = null) => ({
  type: FILTER_PAGE,
  page,
  event,
})
